import { __rest } from "tslib";
import { uniqueId } from '@microsoft/fast-web-utilities';
import React, { forwardRef, useEffect, useRef } from 'react';
import { createReactWrapper } from '../common/PrefixUtils';
import { handleForwardRef } from '../common/RefUtils';
export const NavigationRail = forwardRef((_a, ref) => {
    var { moreLabel, collapseLabel, expandLabel, children, secondaryItems, onToggle } = _a, props = __rest(_a, ["moreLabel", "collapseLabel", "expandLabel", "children", "secondaryItems", "onToggle"]);
    const navigationRailRef = useRef();
    const handledRef = handleForwardRef(navigationRailRef, ref);
    const renderableSecondaryItems = React.useMemo(() => {
        var _a;
        return React.Children.map((_a = secondaryItems === null || secondaryItems === void 0 ? void 0 : secondaryItems.props) === null || _a === void 0 ? void 0 : _a.children, (item) => React.cloneElement(item, {
            slot: 'secondary-items',
            key: uniqueId('navrail-secondary-item-'),
        }));
    }, [secondaryItems]);
    const handleToggle = () => {
        onToggle === null || onToggle === void 0 ? void 0 : onToggle();
    };
    useEffect(() => {
        var _a;
        (_a = navigationRailRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('navrail-toggle', handleToggle);
        return () => {
            var _a;
            (_a = navigationRailRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('navrail-toggle', handleToggle);
        };
    }, [ref, onToggle]);
    return createReactWrapper({
        tagName: 'chameleon-navigation-rail',
        children: (React.createElement(React.Fragment, null,
            children,
            renderableSecondaryItems && renderableSecondaryItems)),
        props: Object.assign(Object.assign({}, props), { ref: handledRef, 'more-label': moreLabel, 'collapse-label': collapseLabel, 'expand-label': expandLabel }),
    });
});
